import { getValidationResult } from 'shared/utils/tools'
import {
  organizationInformationSchema,
  getEmptyOrganizationInformation,
} from 'pages/CustomizeScoreboard/model/organizationInformation'
import * as yup from 'yup'

export const organizationSettingSchema = yup.object().shape({
  organization_information: organizationInformationSchema,
})

export type organizationSettingType = yup.InferType<typeof organizationSettingSchema> & {
  [k: string]: any | undefined
}

export function getEmptyOrganizationSetting(): organizationSettingType {
  return {
    organization_information: getEmptyOrganizationInformation(),
  }
}

export default function validator(data: organizationSettingType) {
  return getValidationResult(data, organizationSettingSchema)
}
